module.exports = __webpack_public_path__ + "img/howtoplay-01.9fded863.jpg";